import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { CompanyConfig } from '../models';

export enum CompanyConfigActionTypes {
  GetCompanyConfigAction = '[CompanyConfig] GetCompanyConfigAction',
  GetCompanyConfigSuccessAction = '[CompanyConfig] GetCompanyConfigSuccess',
  GetCompanyConfigErrorAction = '[CompanyConfig] GetCompanyConfigError',
  SetCompanyConfigIndexAction = '[CompanyConfig] SetCompanyConfigIndexAction',
  SetIsContrastColor = '[CompanyConfig] SetIsContrastColor',
  SetSiteIDAction = '[CompanyConfig] SetSiteIDAction',
  SetOrderFromSiteAction = '[CompanyConfig] SetOrderFromSiteAction',
  ClearQRScanDataAction = '[CompanyConfig] ClearQRScanDataAction',
  SetIsAnonymousAction = '[CompanyConfig] SetIsAnonymousAction',
}

export const getCompanyConfigAction = createAction(CompanyConfigActionTypes.GetCompanyConfigAction);

export const getCompanyConfigSuccessAction = createAction(
  CompanyConfigActionTypes.GetCompanyConfigSuccessAction,
  props<{ companyConfig: CompanyConfig[] }>()
);

export const getCompanyConfigErrorAction = createAction(
  CompanyConfigActionTypes.GetCompanyConfigErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const setCompanyConfigIndexAction = createAction(
  CompanyConfigActionTypes.SetCompanyConfigIndexAction,
  props<{ companyConfigIndex: Array<any> }>()
);

export const setIsContrastColor = createAction(CompanyConfigActionTypes.SetIsContrastColor, props<{ isContrastColor: boolean }>());

export const setSiteIDAction = createAction(CompanyConfigActionTypes.SetSiteIDAction, props<{ siteId: string }>());

export const setOrderFromSiteAction = createAction(CompanyConfigActionTypes.SetOrderFromSiteAction, props<{ orderFromSite: string }>());

export const clearQRScanDataAction = createAction(CompanyConfigActionTypes.ClearQRScanDataAction);

export const setIsAnonymousAction = createAction(CompanyConfigActionTypes.SetIsAnonymousAction, props<{ isAnonymous: boolean }>());
